import { any, array, bool, func, string } from 'prop-types'
import { forwardRef, useMemo } from 'react'
import styled from 'styled-components'
import { Text, TextStyle } from '../Text'
import BaseSelect from 'react-select'

export const Select = forwardRef(
  (
    {
      label,
      error,
      required,
      options,
      valueKey = 'value',
      labelKey = 'label',
      onChange,
      value,
      defaultValue,
      ...props
    },
    ref
  ) => {
    const realOptions = useMemo(
      () => options.map(option => ({ label: option[labelKey], value: option[valueKey] })),
      [options, labelKey, valueKey]
    )

    const realValue = useMemo(() => value && realOptions.find(option => option.value === value), [value, realOptions])

    const realDefaultValue = useMemo(
      () => defaultValue && realOptions.find(option => option.value === defaultValue),
      [defaultValue, realOptions]
    )

    return (
      <Wrap>
        <Label>
          {label}
          {required && ' *'}
        </Label>
        <StyledBaseSelect
          ref={ref}
          options={realOptions}
          {...props}
          onChange={val => onChange && onChange(val.value)}
          value={realValue}
          defaultValue={realDefaultValue}
          classNamePrefix="select"
        />

        {error && <Text color="primary">{error}</Text>}
      </Wrap>
    )
  }
)

Select.displayName = 'Select'
Select.propTypes = {
  label: string,
  onChange: func,
  onBlur: func,
  onFocus: func,
  error: string,
  required: bool,
  options: array,
  valueKey: string,
  labelKey: string,
  value: any,
  defaultValue: any,
  isClearable: bool,
}

const Wrap = styled.div`
  margin-bottom: 1.5rem;
  &:last-child {
    margin-bottom: 0;
  }
`

export const SelectInput = styled.select`
  ${TextStyle}
  font-family: var(--font-family-secondary);
  padding: 0.75rem;
  width: 100%;
  display: block;
  ${({ noBorder }) => !noBorder && `border: 1px solid var(--color-dark-gray);`}
  ${({ noBorder }) => noBorder && `border: 0`}
`
const Label = styled.label`
  ${TextStyle}
  margin-bottom: 0.75rem;
  display: block;
`

const StyledBaseSelect = styled(BaseSelect)`
  .elect__single-value {
    font-size: 13px !important;
  }

  .select__control {
    border: ${({ noBorder }) => (noBorder ? 0 : '1px solid var(--color-dark-gray)')}!important;
  }
`
